import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  deleteLanguage,
  updateLanguageItem,
} from "../../../../redux/slices/multiUrl";
import { handleLink } from "../../../../hooks/helpers";
import InputText from "../../../../components/input/inputText";
import { TrashIcon } from "../svg";
import { Button, Col, Form } from "react-bootstrap";
import InputSelect from "../../../../components/input/inputSelect";
import { MAX_LINK_LENGTH } from "../../../../constants/inputValues";

export default function LanguageItem({ language, languageIndex, error }) {
  const { languages, lang, errorMsg } = useSelector((state) => ({
    languages: state.multiUrl.languages,
    lang: state.changeLang.language.stepTwo,
    errorMsg: state.changeLang.language.stepTwo.errors,
  }));

  const { id, languageId, link, linkValid } = language;

  const dispatch = useDispatch();
  const [allLanguages, setAllLanguages] = useState([]);

  useEffect(() => {
    axios("/api/locale/languages").then(({ data }) => {
      setAllLanguages(
        Object.entries(data).map((item) => {
          return { id: item[1], language: item[0] };
        })
      );
    });
  }, []);

  const handleLanguageSelect = (e) => {
    const selectId = e.target.value;
    dispatch(updateLanguageItem({ id, languageId: selectId }));
  };

  return (
    <>
      <Col xs={12} md={11}>
        <div className="d-flex justify-content-between align-items-center fw-bold mb-1 mt-4">
          <small>
            {lang.multiUrl[20]} {languageIndex}
          </small>
          {languages.length > 1 && (
            <Button
              variant="link"
              onClick={() => dispatch(deleteLanguage(id))}
              className="p-0 cursor-pointer"
            >
              <TrashIcon
                style={{
                  color: "#F44336",
                  cursor: "pointer",
                }}
              />
            </Button>
          )}
        </div>
      </Col>

      <InputSelect
        name="language"
        value={languageId}
        onChange={handleLanguageSelect}
        defaultlabel={lang.multiUrl[21]}
        errorMessage={
          error &&
          !languageId && (
            <Form.Text className="text-danger">{lang.multiUrl[2]}</Form.Text>
          )
        }
        popoverText={lang.multiUrl[39]}
      >
        <option disabled={true} value={""}>
          {lang.multiUrl[21]}
        </option>
        {allLanguages.map((item) => (
          <option key={item.id} value={item.id}>
            {item.language}
          </option>
        ))}
      </InputSelect>

      <InputText
        valid={linkValid && link.length > 3 && link.length <= MAX_LINK_LENGTH}
        error={
          (!linkValid && link.length > 3) ||
          (error && !link.length && !linkValid) ||
          link.length > MAX_LINK_LENGTH
        }
        type="link"
        name="languageLink"
        value={link}
        onChange={(e) =>
          handleLink(
            e.target.value,
            (linkValid) => dispatch(updateLanguageItem({ id, linkValid })),
            (link) => dispatch(updateLanguageItem({ id, link }))
          )
        }
        placeholder={lang.multiUrl[23]}
        popoverText={lang.multiUrl[40]}
      >
        {linkValid === false && link.length > 3 && (
          <Form.Text className="text-danger">
            {lang.link[2]}: https://me-qr.com/
          </Form.Text>
        )}
        {error && !link.length && !linkValid && (
          <Form.Text className="text-danger">{lang.linkEmpty}</Form.Text>
        )}
        {!linkValid && link.length > 0 && link.length < 4 && (
          <Form.Text className="text-danger">{lang.link[22]}</Form.Text>
        )}
        {link.length > MAX_LINK_LENGTH && (
          <Form.Text className="text-danger">{errorMsg[0]}</Form.Text>
        )}
      </InputText>
    </>
  );
}
